import React, { PureComponent, Fragment } from 'react';
import { Divider, Popconfirm as AntPopconfirm } from 'antd';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { isUndefined } from 'lodash';

const A = props => {
    const { children, ...restProps } = props;
    return <a {...restProps}>{children}</a>;
};

A.propTypes = {
    children: PropTypes.node.isRequired,
};

export default class Action extends PureComponent {
    static defaultProps = {
        // items: [],
        hashPath: true,
    };

    static propTypes = {
        items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        hashPath: PropTypes.bool,
    };

    render() {
        return this.props.items
            .filter(item => {
                const { is } = item;
                return !isUndefined(item) && item && (isUndefined(is) || is);
            })
            .map((item, key) => {
                item.id = key;
                const {
                    title,
                    text,
                    onClick,
                    component: Component = A,
                    is,
                    to,
                    href = to,
                    disabled,
                    className,
                    ...restProps
                } = item;
                const divider = key ? <Divider type="vertical" /> : null;
                let mergeProps = { ...restProps, className };
                if (disabled) {
                    if (Component === A) {
                        mergeProps = {
                            ...mergeProps,
                            className: classNames(className, 'disabled'),
                            disabled,
                        };
                    } else {
                        mergeProps = { ...mergeProps, disabled };
                    }
                }
                if (href && Component === A) {
                    mergeProps = { ...mergeProps, href: href };
                } else if (Component === Link) {
                    mergeProps = { ...mergeProps, to };
                }
                let action = null;
                switch (item.type) {
                    case 'confirm':
                        action = (
                            <AntPopconfirm title={title || '您确定要删除这条数据吗？'} onConfirm={onClick}>
                                <Component {...mergeProps}>{text || '删除'}</Component>
                            </AntPopconfirm>
                        );
                        break;
                    default:
                        action = (
                            <Component onClick={onClick} {...mergeProps}>
                                {text || '编辑'}
                            </Component>
                        );
                        break;
                }
                return (
                    <Fragment key={item.id}>
                        {divider}
                        {action}
                    </Fragment>
                );
            });
    }
}
